import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authReducer from "./slices/authSlice";
import dashboardReducer from "./slices/dashboardSlice";
import vehicleAccountReducer from "./slices/VehicleAccountSlice";
import focMasterReducer from "./slices/focMasterSlice";
import historyReducer from "./slices/VehicleHistorySlice";
import corporateReducer from "./slices/corporateSlice";
import rootSaga from "../redux/rootSaga";
import prepaidReducer from "./slices/prepaidSlice";
import corporatetripReducer from "./slices/CorporateTripSlices";
import DriverAttenReducer from "./slices/DriverAttenSlice";
import bookingReducer from "./slices/bookingReportSlice";
import driverdetailsReducer from "./slices/DriverSlice";
import ownerdetailsReducer from "./slices/OwnerSlice";
import statusreportReducer from "./slices/StatusReportSlice"


const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    vehicleAccount: vehicleAccountReducer,
    focMaster: focMasterReducer,
    history: historyReducer,
    corporate: corporateReducer,
    prepaid: prepaidReducer,
    CorTrip: corporatetripReducer,
    driverAtten: DriverAttenReducer,
    booking: bookingReducer,
    driverdetails: driverdetailsReducer,
    ownerdetails: ownerdetailsReducer,
    statusreport:statusreportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});
sagaMiddleware.run(rootSaga);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
